// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0bc3ac3e","453":"807eb80c","455":"c59160b9"}[chunkId] + ".chunk.js";
};